// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__30wau","calendarButtons":"ClockData_calendarButtons__1BPbs"};